import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { toastAnimations } from 'src/app/core/toast/toast.animations';
import { selectToasts } from 'src/app/core/toast/toast.selectors';
import { ToastState } from 'src/app/core/toast/toast.state';

@Component({
	selector: 'ahp-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	animations: [toastAnimations.fadeToast],
})
export class ToastComponent implements OnInit {
	toastMessages$: Observable<ToastState>;

	constructor(private store: Store<AppState>) {
		this.toastMessages$ = store.select(selectToasts);
	}

	ngOnInit(): void {}
}
